export default __webpack_public_path__ + "fonts/DINPro-Bold.woff2";